import React from 'react';
//import { PropTypes } from 'prop-types';
import { Row, Col  } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import EmailsList from './EmailsList/EmailsList';


function EmailsContainer(props) {
    const { eventID } = props;
    //const [ modalShow, setModalShow ] = useState(false);
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <Row>
                <Col md={12}>
                    <h3>{t('emails.emails_header')}</h3>
                    <EmailsList
                        eventID={eventID}
                        create={true}
                        limit={25}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default EmailsContainer;